module.exports = __webpack_public_path__ + "static/siderailimg-9913c600a5b234829e5733d201c28b07.png";